import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as APIS from "../../constants/actionTypes";
import get from "lodash/get";

const initialState = {
  token: null,
  isLoggedIn: null,
  user: null,
  isSuperAdmin: false,
  permissions: {},
  assignedCabinets: {},
};

export const login = createAsyncThunk(
  "auth",
  async (credentials, { dispatch, getState, extra }) => {
    const { api } = extra;
    return api
      .post(APIS.LOGIN, credentials)
      .then((result) => {
      return result;
      })
      .catch((error) => {
        throw error;
      });
  }
);

export const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    logOut: (state) => {
      state.token = null;
      state.isLoggedIn = null;
      state.user = null;
      state.isSuperAdmin = null;
      state.permissions = null;
      state.assignedCabinets = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      state.isLoggedIn = true;
      state.token = get(action, "payload.token");
      state.user = get(action, "payload.user");
      state.isSuperAdmin = get(action, "payload.is_super_admin", false);
      state.permissions = get(action, "payload.assigned_permissions", {});
      state.assignedCabinets = get(action, "payload.assigned_cabinets", {});
    });
    builder.addCase(login.rejected, (state) => {
      state.token = null;
      state.isLoggedIn = false;
      state.user = null;
      state.isSuperAdmin = null;
      state.permissions = null;
      state.assignedCabinets = null;
    });
  },
});

export const { logOut } = authSlice.actions;
export default authSlice.reducer;
